import { API } from 'api'
import { User, UserProfile } from 'shared'

export interface AUTH {
  email: string
  password: string
}

const ENDPOINT = '/auth'

export const register = (data: AUTH) => {
  return API.post(`${ENDPOINT}/sign-up`, data).then((res) => res.data)
}

export const login = (data: AUTH) => {
  return API.post(`${ENDPOINT}/sign-in`, data).then((res) => res.data)
}

export const verify = (data: { email: string; code: string }) => {
  return API.post(`${ENDPOINT}/verify`, data).then((res) => res.data)
}

export const resetPassword = (
  data: AUTH & { code: string; user_id: string }
) => {
  return API.post(`${ENDPOINT}/reset-password`, data).then((res) => res.data)
}

export const changePassword = (data: {
  previousPassword: string
  proposedPassword: string
  accessToken: string
}) => {
  return API.post(`${ENDPOINT}/change-password`, data).then((res) => res.data)
}

export const getUser = (): Promise<User> => {
  return API.get(`${ENDPOINT}/me`).then((res) => res.data)
}

export const createProfile = (profileData: UserProfile) => {
  return API.post(`${ENDPOINT}/me`, profileData).then((res) => res.data)
}

export const logout = () => {
  return API.post(`${ENDPOINT}/logout`).then((res) => res.data)
}

export const verifyRetry = (data: { email: string }) => {
  return API.post(`${ENDPOINT}/verify/retry`, data).then((res) => res.data)
}

export const forgotPassword = (data: { email: string }) => {
  return API.post(`${ENDPOINT}/forgot-password`, data).then((res) => res.data)
}

export const changeEmail = (data: { email: string }) => {
  return API.post(`${ENDPOINT}/change-email`, data).then((res) => res.data)
}

export const verifyUpdatedEmail = (data: { email: string; code: string }) => {
  return API.post(`${ENDPOINT}/verify-updated`, data).then((res) => res.data)
}
